import { SVGProps } from 'react';

const AngleLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M17.172 24a1 1 0 0 1-.707-.293l-8.172-8.172a5 5 0 0 1 0-7.07L16.465.293a1 1 0 0 1 1.414 1.414L9.707 9.879a3 3 0 0 0 0 4.242l8.172 8.172A1 1 0 0 1 17.172 24Z" />
  </svg>
);

export default AngleLeft;
